import { createContext, useContext, useEffect } from "react";

export interface IFlowHeaderContext {
  setProgress: (progress: number) => void;
  setShowStatic: (showStatic: boolean) => void;
}

export const FlowHeaderContext = createContext<IFlowHeaderContext | null>(null);

export function useFlowHeaderContext() {
  const flowHeaderContext = useContext(FlowHeaderContext);
  if (!flowHeaderContext) throw new Error("No FlowHeaderContext found!");
  return flowHeaderContext;
}

export function useSetStaticFlowHeader() {
  const flowHeaderContext = useFlowHeaderContext();
  useEffect(() => {
    flowHeaderContext.setShowStatic(true);
    return () => flowHeaderContext.setShowStatic(false);
  }, [flowHeaderContext]);
}
